export const SET_IS_LOGIN ="SET_IS_LOGIN"
export const SET_USER = 'SET_USER'